module.exports = __webpack_public_path__ + "static/media/014admin_2 queue@2x.ca00bfb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/optus/014admin_2 queue@2x.png
// module id = 578
// module chunks = 0